module.exports = __webpack_public_path__ + "static/media/OrangePeeltshirtAshevilleNC2009.103398e5.webp";